"use client"

import { MailSearch } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MailSearchIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MailSearchIcon = component(Icon)({ as: MailSearch })
